import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

export const itemDetails: ThemeUICSSObject = {
  /* PREPEND HERE */
};
